import {
  BenchmarkHistoryRequestParams,
  BenchmarkHistoryResponse,
} from './types';

const url = 'https://benchmarks.pyth.network/v1/shims/tradingview/history';

export const fetcher = async ({
  from,
  resolution,
  symbol,
  to,
}: BenchmarkHistoryRequestParams): Promise<BenchmarkHistoryResponse> => {
  const _url = `${url}?symbol=${symbol}&resolution=${resolution}&from=${from}&to=${to}`;
  const res = await fetch(_url);
  const response = (await res.json()) as BenchmarkHistoryResponse;

  return response;
};
